import HttpService from './HttpService';
import { getUrlPlantApi, translate, showMessageToastCustom, getApiKeyLogistics } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import * as unitAction from '../actions/unitAction';

const httpService = new HttpService(getUrlPlantApi(window), getApiKeyLogistics(window));
export default class UnitService {
    static getUnits(vision, filter, pagination) {
        pagination.PageSize = 40;
        Object.assign(filter, pagination);
        const url = 'api/unit';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(
                    url,
                    {
                        params: filter,
                        timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response.status === 200) {
                        dispatch(unitAction.setUnits(response.data.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static AddUnit = (unit, callback) => {
        const url = 'api/unit';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, unit, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 201) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PutUnit = (unit, callback) => {
        const url = 'api/unit';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, unit, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static DeleteUnit = (unitId, callback) => {
        const url = 'api/unit';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(`${url}/${unitId}`, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 204) {
                        if (callback) {
                            callback({ message: "Item excluido com sucesso" });
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }


    static getUnitOrdering(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/unitordering`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data) {
                            dispatch(unitAction.setUnitOrdering(response.data));
                            if (callback) {
                                callback();
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static DeleteSelectedUnits(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/unit/selected`;
            return (dispatch) => {
                if (navigator.onLine) {
                    dispatch(startLoading());
                    httpService.instance.put(url, ids, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback({ message: "Itens excluidos com sucesso" });
                            }
                        } else {
                            showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                        }
                    }).catch((error) => {
                        dispatch(endLoading());
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
                }
            };
        }
    }
}
